@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.topBarContainer {
  @include transition;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px;

  [data-autopilot-system-redesign='on'] & {
    position: fixed;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    height: 60px;
    border-bottom: 1px solid var(--dark-4);
    padding: 0 20px;
    background: var(--light-100);
    z-index: 12;
  }

  @media (min-width: $tabletLandscapeMaxWidth) {
    padding-left: 0;
  }

  &.distributeEvenly {
    [data-ff-calendar-review-button='on'] & {
      grid-template-columns: 1fr auto 1fr;
    }
  }

  .leftButtons,
  .rightButtons {
    display: flex;
    align-items: center;
    gap: 5px;
    button {
      font-weight: 400;
    }
  }

  .leftButtons {
    justify-content: flex-start;
  }

  .rightButtons {
    justify-content: flex-end;
  }

  &.noRightPadding {
    padding-right: 0;
  }
}

.upgradeButton {
  min-height: 40px;
}

.referButton {
  border-radius: 990px;
}

.topBarContent {
  @include transition;
  @include blur(35px);
  display: flex;
  gap: 1px;
  align-items: center;
  width: 100%;
  padding: 5px 33px;
  background: var(--light-90);
  box-shadow: 0 7px 22px 0 rgba(0, 0, 0, 0.1);
  position: fixed;
  z-index: 1;
  top: 0;
  opacity: 0;
  pointer-events: none;

  [data-autopilot-system-redesign='on'] & {
    @include blur(0px);
    box-shadow: none;
    background: transparent;
    gap: 2px;
    justify-content: center;
    height: 60px;
  }

  &.visible {
    opacity: 1;
    pointer-events: all;
  }

  .label {
    margin-right: 12px;
  }
}

.centerContent {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}
